import { render, staticRenderFns } from "./AllowedProducts.vue?vue&type=template&id=42023daa"
import script from "./AllowedProducts.vue?vue&type=script&lang=js"
export * from "./AllowedProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports